import PediatricIndicatorIcon from '../../../components/Icons/PediatricIndicatorIcon';
import { getPediatricIndicator } from '../utils/getAgeForPediatricIndicator';

export const PediatricIndicatorRenderer = ({ row }) => {
  const isAgeLessThan18 = getPediatricIndicator(
    row._original.admission_date,
    row._original.birth_date
  );
  if (isAgeLessThan18) {
    return <PediatricIndicatorIcon />;
  }
  return '';
};
